export default class Media {
  breakpoints: Object;
  constructor() {
    this.breakpoints = {
      'mobile': 20,
      'phablet': 31.25,
      'tablet': 48.125,
      'tablet_ls': 64,
      'desktop': 68.75,
      'wide': 71.875,
      'laptop': 87.5,
      'super_wide': 100,
    }
  }

  from(breakpoint: string) {
    if (!(breakpoint in this.breakpoints)) return;
    let mediaQuery = window.matchMedia(`(min-width: ${this.breakpoints[breakpoint]}em)`);
    return mediaQuery.matches;
  }

  until(breakpoint: string) {
    if (!(breakpoint in this.breakpoints)) return;
    let mediaQuery = window.matchMedia(`(max-width: ${(this.breakpoints[breakpoint]) - 0.01}em)`);
    return mediaQuery.matches;
  }
}
